import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import GoogleSignInButton from "@/components/GoogleSignInButton";

export default function Login() {
  const { t } = useLang();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await login(form.email, form.password);
      toast.success(`${t("dashboard.welcome")}, ${data.name}`);
      navigate(data.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally { setSubmitting(false); }
  };
  return (
    <div data-testid="login-page" className="container-refined py-16 md:py-24 max-w-md">
      <p className="eyebrow">Sunbraider</p>
      <h1 className="mt-4 font-serif text-4xl text-forest-900">{t("auth.login_title")}</h1>
      <div className="mt-10 space-y-4">
        <GoogleSignInButton label={t("auth.google_continue")} testId="login-google-btn" />
        <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.28em] text-forest-700/60">
          <span className="flex-1 h-px bg-forest-900/10" />
          {t("auth.or_email")}
          <span className="flex-1 h-px bg-forest-900/10" />
        </div>
      </div>
      <form onSubmit={submit} className="mt-6 space-y-5" data-testid="login-form">
        <div>
          <label className="field-label">{t("auth.email")}</label>
          <input required type="email" data-testid="login-email" className="field-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <div>
          <label className="field-label">{t("auth.password")}</label>
          <input required type="password" data-testid="login-password" className="field-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </div>
        <button disabled={submitting} className="btn-primary w-full justify-center" data-testid="login-submit">
          {submitting ? t("common.loading") : t("auth.submit_login")}
        </button>
        <p className="text-sm text-forest-700 text-center">
          {t("auth.no_account")} <Link to="/register" className="underline underline-offset-4 hover:text-forest-900" data-testid="login-register-link">{t("nav.register")}</Link>
        </p>
      </form>
    </div>
  );
}
